<template>
  <div class="create-account-success">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-sheet class="mb-0 top-card" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <h2 class="mt-0">
              <v-icon color="greenMain">mdi mdi-account-outline</v-icon>Investor
              Account Detail
            </h2>
            <p class="mb-0">
              Your Investor Account Details has been sent to
              <span class="text--green">{{ client?.email }}</span>
            </p>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6">
          <v-sheet class="mb-0 bottom-card" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <div class="icon-success d-flex flex-column justify-center align-center">
              <v-icon color="greenMain" x-large>mdi mdi-account-check-outline</v-icon>
              <span>Congratulations</span>
            </div>
            <ul class="listing">
              <li><span class="text--green">MT5 Login ID:</span>{{ tradingAccountInfo?.account_no }}</li>
              <li>
                <span class="text--green">MT5 Investor Password:</span>{{ tradingAccountInfo?.investor_password }}
              </li>
              <li>
                <span class="text--green">MT5 Server:</span>{{ tradingAccountInfo?.server }}
              </li>
              <li>
                <span class="text--green">Download MT5:</span>
                <v-btn text small class="text-capitalize" @click="handleDownload(tradingAccountInfo?.download)">
                  Download Here
                </v-btn>
              </li>
            </ul>
            <div class="text-center">
              <v-btn tile outlined elevation="0" width="250px" to="/dashboard" class="text-capitalize btn-account"
                color="greenMain">go to dashboard</v-btn>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      slots: ["Gold", "Silver", "Bronze"],
      slots2: ["1:500", "1:1200", "1:100"],
      show1: false,
      show2: false,
      password: "",
      password2: "",
      e1: 1,
    };
  },
  computed: {
    ...mapState("mam", ["tradingAccountInfo"]),
    ...mapState("profile", ["client"]),
  },
  methods: {
    ...mapActions("profile", [PROFILE__ACTIONS.GETPROFILE]),

    handleDownload(downloadUrl) {
      this.$router.push(downloadUrl);
    }
  },
  async mounted() {
    try {
      await this[PROFILE__ACTIONS.GETPROFILE]();
    } catch (error) {
      console.log(error);
    }
  }
};
</script>
